var questionState = 0;
var quizActive = true;
var userStats = [0, 0, 0, 0, 0, 0];
var tempStats = userStats;

// Updated question and answer arrays (no pregnancy question)
var questionText = [
    "How would you describe your skin type?",
    "To help us with your recommendation, what is your age?",
    "What is your gender?",
    "How would you describe your main beauty and wellness goal?",
    "Do you follow a vegan diet?"
];

var answerText = [
    ["Normal skin", "Combination skin", "Oily or acne prone skin", "Sensitive skin", "Dull or dry skin", "Dehydrated", "Eczema or psoriasis prone", "Early signs of aging", "Mature skin"],
    ["18-24", "25-30", "31-40", "41-50", "51-60", "60+"],
    ["Female", "Male", "Prefer not to say"],
    ["Skin glow & radiance", "Reduce fine lines & wrinkles", "Help acne flare-ups", "Help dry skin flare-ups", "Thicker, fuller hair", "Stronger nails", "Revive menopausal skin & hair", "Help with sleep and relaxation", "Support with focus and reducing brain fog"],
    ["Yes", "No"]
];

var products = [
    {
        name: "Original",
        image: "https://cdn.shopify.com/s/files/1/0739/5816/2730/files/UK_OG_copy_a9cdbd8f-5593-4434-b3a0-7b415b54be6e.jpg?v=1722853858",
        link: "/products/revive-collagen-hydrolysed-marine-collagen-drink?selling_plan=8413643050"
    },
    {
        name: "Enhanced Plus",
        image: "https://cdn.shopify.com/s/files/1/0739/5816/2730/files/UK_EP_copy_91d0c96c-9113-4e42-8c38-4631a3e1a2ec.jpg?v=1722853858",
        link: "/products/revive-collagen-plus-hydrolysed-marine-collagen-drink?selling_plan=8363180330"
    },
    {
        name: "Vegan",
        image: "https://cdn.shopify.com/s/files/1/0739/5816/2730/files/UK_Vegan_copy_47fbc52c-4b0c-4bf6-b01d-15b4ff51cb41.jpg?v=1722853858",
        link: "/products/revive-collagen-vegan-the-worlds-first-clinically-proven-vegan-collagen"
    },
    {
        name: "Menopause Max",
        image: "https://cdn.shopify.com/s/files/1/0739/5816/2730/files/UK_Max_copy_6d4a42eb-503d-4cd0-ac81-62165c63884e.jpg?v=1722853858",
        link: "/products/revive-collagen-menopause-max-collagen-drink?selling_plan=8418296106"
    },
    {
        name: "Peri Menopause",
        image: "https://cdn.shopify.com/s/files/1/0739/5816/2730/files/UK_Peri_copy_fb0a3371-863a-4e7a-a493-3a3b02063302.jpg?v=1722853858",
        link: "/products/revive-collagen-peri-menopause-collagen-drink"
    },
    {
        name: "Menopause Beauty Sleep",
        image: "https://cdn.shopify.com/s/files/1/0739/5816/2730/files/UK_Max_copy_6d4a42eb-503d-4cd0-ac81-62165c63884e.jpg?v=1722853858",
        link: "/products/revive-collagen-menopause-beauty-sleep-collagen-drink"
    },
    {
        name: "Sleep & Inner Calm",
        image: "https://cdn.shopify.com/s/files/1/0437/6844/7141/files/Sleep_inner-quiz.jpg?v=1760624361",
        link: "/products/sleep-inner-calm"
    },
    {
        name: "Concentration & Clarity",
        image: "https://cdn.shopify.com/s/files/1/0437/6844/7141/files/CClosenge.jpg?v=1757953159",
        link: "/products/concentration-and-clarity"
    }
];

var results = document.getElementById("rcq-results");
var quiz = document.getElementById("rcq-quiz");
var loadingContainer = document.getElementById("rcq-loading-container");
var productRecommendation = document.getElementById("rcq-product-recommendation");
var buttonElement = document.getElementById("rcq-button");
buttonElement.addEventListener("click", changeState);

// Preload product images
function preloadImages() {
    products.forEach(product => {
        const img = new Image();
        img.src = product.image;
    });
}

// Call this function when the page loads
window.onload = preloadImages;

function changeState() {
    if (quizActive) {
        animateQuestionOut();
        setTimeout(() => {
            initText(questionState);
            questionState++;
            animateQuestionIn();
        }, 100);
    } else {
        setCustomPage();
    }
    scrollToQuiz();
}

function initText(question) {
    var answerSelection = "";
    for (var i = 0; i < answerText[question].length; i++) {
        answerSelection += "<li><input type='radio' name='question" +
            (question + 1) + "' onClick='setAnswer(" + i + ")' id='" + answerText[question][i] + "'><label for='" + answerText[question][i] + "' class='rcq-quiz-btn'>" + answerText[question][i] + "</label></li>";
    }
    document.getElementById("rcq-questions").innerHTML = questionText[question];
    document.getElementById("rcq-answers").innerHTML = answerSelection;
    buttonElement.style.display = "none";
    document.getElementById("rcq-back-button-container").style.display = "block";
    document.getElementById("rcq-quiz-title").style.display = "none";
    resetButtonStyles();
}

function resetButtonStyles() {
    var buttons = document.querySelectorAll('#rcq-answers li, #rcq-button');
    buttons.forEach(function(button) {
        button.style.opacity = '1';
    });
}

function setAnswer(input) {
    // Remember: By the time user selects an answer for question n,
    // questionState is n+1.
    // Q0 answer => questionState = 1
    // Q1 answer => questionState = 2
    // Q2 answer => questionState = 3
    // Q3 answer => questionState = 4
    // Q4 answer => questionState = 5

    if (questionState === 1) {
        // After Q0 answer
        changeState(); // Moves to Q1
    } else if (questionState === 2) {
        // After Q1 answer
        changeState(); // Moves to Q2
    } else if (questionState === 3) {
        // After Q2 answer
        changeState(); // Moves to Q3
    } else if (questionState === 4) {
        // After Q3 (Beauty goal) answer
        userStats[3] = input;
        changeState(); // Moves to Q4 (Vegan)
    } else if (questionState === 5) {
        // After Q4 (Vegan) answer
        if (input === 0) {
            // User is vegan
            showLoadingScreen(2); // Vegan product
        } else if (input === 1) {
            // Not vegan => Determine final product recommendation based on beauty goal
            switch (userStats[3]) {
                case 0: // Skin glow & radiance
                    showLoadingScreen(0, 1); // Original, Enhanced Plus
                    break;
                case 1: // Fine lines & wrinkles
                    showLoadingScreen(1, 4); // Enhanced Plus, Peri Menopause
                    break;
                case 2: // Help Acne flare-ups
                    showLoadingScreen(0); // Original
                    break;
                case 3: // Help Dry or dehydrated
                    showLoadingScreen(0, 2); // Original, Vegan
                    break;
                case 4: // Thicker fuller hair
                    showLoadingScreen(1, 3); // Enhanced Plus, Menopause Max
                    break;
                case 5: // Stronger nails
                    showLoadingScreen(1); // Enhanced Plus
                    break;
                case 6: // Revive menopausal skin & hair
                    showLoadingScreen(3, 4); // Menopause Max, Peri Menopause
                    break;
                case 7: // Help with sleep and relaxation
                    showLoadingScreen(5, 6); // Menopause Beauty Sleep, Sleep & Inner Calm
                    break;
                case 8: // Support with focus and reducing brain fog
                    showLoadingScreen(7); // Concentration & Clarity
                    break;
            }
        }
    }
    scrollToQuiz();
}

function goBack() {
    if (results.style.display === "block") {
        results.style.display = "none";
        quiz.style.display = "block";
        questionState -= 1;
    } else if (questionState === 1) {
        // Reset to the initial quiz start screen
        questionState = 0;
        document.getElementById("rcq-quiz-title").style.display = "block";
        document.getElementById("rcq-questions").innerHTML = "Are you ready to start the quiz?";
        document.getElementById("rcq-answers").innerHTML = "";
        buttonElement.style.display = "inline-block";
        document.getElementById("rcq-back-button-container").style.display = "none";

        quiz.classList.add('rcq-fade-in-start');
    } else if (questionState > 1) {
        questionState -= 2;
        if (questionState < 0) questionState = 0;
        animateQuestionOut();
        setTimeout(() => {
            initText(questionState);
            questionState++;
            animateQuestionIn();
        }, 100);
    }
    scrollToQuiz();
}

function animateQuestionOut() {
    var quizContainer = document.getElementById("rcq-quiz-container");
    quizContainer.classList.add("fade-out");
    setTimeout(() => {
        quizContainer.classList.remove("fade-out");
    }, 100);
}

function animateQuestionIn() {
    var quizContainer = document.getElementById("rcq-quiz-container");
    quizContainer.classList.add("fade-in");
    setTimeout(() => {
        quizContainer.classList.remove("fade-in");
    }, 500);
}

function displayCustomPage(...productIndices) {
    var productHTML = '<div class="rcq-product-container">';
    productIndices.forEach(index => {
        var product = products[index];
        productHTML += `
            <div class="rcq-product">
                <h4>${product.name}</h4>
                <a href="${product.link}" class="rcq-product-link">
                    <img src="${product.image}" alt="${product.name}" class="rcq-product-image">
                </a>
                <a href="${product.link}" class="rcq-btn rcq-btn-primary">Shop Now</a>
            </div>
        `;
    });
    productHTML += '</div>';
    productRecommendation.innerHTML = productHTML;
    loadingContainer.classList.add("fade-out");
    setTimeout(() => {
        loadingContainer.style.display = "none";
        results.style.display = "block";
        results.classList.add("fade-in-results");
        setTimeout(() => {
            results.classList.remove("fade-in-results");
        }, 500);
    }, 500);
    document.getElementById("rcq-back-button-container").style.display = "block";
}

function showLoadingScreen(...productIndices) {
    quiz.style.display = "none";
    loadingContainer.style.display = "block";
    setTimeout(() => {
        displayCustomPage(...productIndices);
    }, 2000);
}

function scrollToQuiz() {
    var quizContainer = document.getElementById("rcq-quiz-container");
    quizContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

document.getElementById("rcq-back-button").addEventListener("click", goBack);
